import Vue from "vue";
import Router from "vue-router";
import { getCookie, setCookie, getUrlParams, oauthbycode } from "@/api/login";
import store from "@/store";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

const Bill = () => import(/* webpackChunkName: "bill" */ "@/view/bill");
const Prodused = () =>
  import(/* webpackChunkName: "prodused" */ "@/view/prodused");
const Payhistory = () =>
  import(/* webpackChunkName: "payhistory" */ "@/view/payhistory");
// begin--详单
const Detail = () => import(/* webpackChunkName: "detail" */ "@/view/detail");
const Interim = () =>
  import(/* webpackChunkName: "detail" */ "@/view/detail/interim.vue");
const Query = () => import(/* webpackChunkName: "query" */ "@/view/query");
const Manage = () => import(/* webpackChunkName: "manage" */ "@/view/manage");
const Voice = () =>
  import(/* webpackChunkName: "voice" */ "@/view/detail/voice.vue");
const Mess = () =>
  import(/* webpackChunkName: "mess" */ "@/view/detail/mess.vue");
const Mms = () =>
  import(/* webpackChunkName: "mess" */ "@/view/detail/mms.vue");
const Web = () =>
  import(/* webpackChunkName: "mess" */ "@/view/detail/web.vue");
// end--详单
const Remind = () => import(/* webpackChunkName: "remind" */ "@/view/remind");
const Home = () => import(/* webpackChunkName: "home" */ "@/view/home");
const Protocolchange = () => import(/* webpackChunkName: "home" */ "@/view/protocolchange");

const Fee = () => import(/* webpackChunkName: "fee" */ "@/view/fee");
const Login = () => import(/* webpackChunkName: "login" */ "@/view/login");
const TestReturn = () => import(/* webpackChunkName: "testReturn" */ "@/view/testReturn");
const Code = () =>
  import(/* webpackChunkName: "login" */ "@/view/login/code.vue");
const Reset = () =>
  import(/* webpackChunkName: "login" */ "@/view/login/reset.vue");
const Forget = () =>
  import(/* webpackChunkName: "login" */ "@/view/login/forget.vue");
const User = () => import(/* webpackChunkName: "user" */ "@/view/user");
const Cart = () => import(/* webpackChunkName: "cart" */ "@/view/cart");
const Goods = () => import(/* webpackChunkName: "goods" */ "@/view/goods");

const Baseinfo = () =>
  import(/* webpackChunkName: "temporary" */ "@/view/baseinfo");
const ChargedisSrc = () =>
  import(/* webpackChunkName: "Chargedist" */ "@/view/chargedis/indexs.vue");
const RiceCharge = () =>
  import(/* webpackChunkName: "chargedis" */ "@/view/chargedis/riceCharge.vue");

const About = () =>
  import(/* webpackChunkName: "about" */ "@/view/login/About");

const Gettype = () =>
  import(/* webpackChunkName: "activate" */ "@/view/activate/gettype.vue/");
const Actorder = () =>
  import(/* webpackChunkName: "activate" */ "@/view/activate/");
const Actverify = () =>
  import(/* webpackChunkName: "activate" */ "@/view/activate/verify.vue");
const ForeignVerify = () =>
    import(/* webpackChunkName: "activate" */ "@/view/activate/forerignverify.vue");
const Actgroupphoto = () =>
  import(/* webpackChunkName: "transfer" */ "@/view/activate/groupphoto.vue");

const Actvideo = () =>
  import(/* webpackChunkName: "activate" */ "@/view/activate/video.vue");

const ActvideoTU = () =>
  import(/* webpackChunkName: "activate" */ "@/view/activate/videoTU.vue");
const Onlinevideo = () =>
  import(/* webpackChunkName: "activate" */ "@/view/activate/onlinevideo.vue");

const Actcharge = () =>
  import(/* webpackChunkName: "activate" */ "@/view/charge/act");

const Actchargeprod = () =>
  import(/* webpackChunkName: "activate" */ "@/view/activate/prodCharge.vue");
const handSignResult = () =>
    import(/* webpackChunkName: "activate" */ "@/view/activate/result.vue");
//begin  天津代理商需求
const TJActorder = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/");
const TJActverify = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/verify.vue");

const TJActgroupphoto = () =>
    import(/* webpackChunkName: "transfer" */ "@/view/TJactivate/groupphoto.vue");

const TJActvideo = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/video.vue");

const TJActvideoTU = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/videoTU.vue");

//视频截图
const TJVideoScreenshot = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/videoScreenshot.vue");

const TJOnlinevideo = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/onlinevideo.vue");


const TJActchargeprod = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/prodCharge.vue");
const TJSignResult = () =>
    import(/* webpackChunkName: "activate" */ "@/view/TJactivate/result.vue");
//END  天津代理商需求


// const Actcharge2 = () => import(/* webpackChunkName: "activate" */'@/view/charge/act/index2.vue')
const Rechargeorder = () =>
  import(/* webpackChunkName: "charge" */ "@/view/charge/chargeorder");

const Replaceorder = () =>
  import(/* webpackChunkName: "replace" */ "@/view/replace/index.vue");
const Replacefront = () =>
  import(/* webpackChunkName: "replace" */ "@/view/replace/front.vue");
const Replaceback = () =>
  import(/* webpackChunkName: "replace" */ "@/view/replace/back.vue");
const Replacevideo = () =>
  import(/* webpackChunkName: "replace" */ "@/view/replace/video.vue");

// begin-图片压缩
const Img = () => import(/* webpackChunkName: "img" */ "@/view/img/");
// end-图片压缩

// begin -名下号码查询

const Idqueryorder = () =>
  import(/* webpackChunkName: "idquery" */ "@/view/rep/");
const Idqueryfront = () =>
  import(/* webpackChunkName: "idquery" */ "@/view/rep/front.vue");

const Idqueryback = () =>
  import(/* webpackChunkName: "idquery" */ "@/view/rep/back.vue");
const Idqueryvideo = () =>
  import(/* webpackChunkName: "idquery" */ "@/view/rep/video.vue");
const Idquerylist = () =>
  import(/* webpackChunkName: "idquery" */ "@/view/rep/list.vue");
const IdqueryLiveResult = () =>
    import(/* webpackChunkName: "realTuvideo" */ "@/view/rep/result.vue");
const Idqueryhat = () =>
    import(/* webpackChunkName: "realTuvideo" */ "@/view/rep/hat.vue");
// end -名下号码查询

// begin -实名制补录

const Realcheck = () =>
  import(/* webpackChunkName: "realname" */ "@/view/realname/");
const Realverify = () =>
  import(/* webpackChunkName: "realname" */ "@/view/realname/verify.vue");
const Realgroupphoto = () =>
  import(/* webpackChunkName: "realname" */ "@/view/realname/groupphoto.vue");
const Realfront = () =>
  import(/* webpackChunkName: "realname" */ "@/view/realname/front.vue");
const Realback = () =>
  import(/* webpackChunkName: "realname" */ "@/view/realname/back.vue");
const RealVideo = () =>
  import(/* webpackChunkName: "realvideo" */ "@/view/realname/realvideo.vue");
const Record = () =>
  import(/* webpackChunkName: "realname" */ "@/view/realname/record.vue");
const RealTuVideo = () =>
    import(/* webpackChunkName: "realTuvideo" */ "@/view/realname/videoTU.vue");
const LiveResult = () =>
    import(/* webpackChunkName: "realTuvideo" */ "@/view/realname/result.vue");
// begin ----  补换卡

const Cardorder = () =>
  import(/* webpackChunkName: "changecd" */ "@/view/changecd/");
const CardVerify = () =>
  import(/* webpackChunkName: "changecd" */ "@/view/changecd/verify.vue");

const Cardvideo = () =>
  import(/* webpackChunkName: "changecd" */ "@/view/changecd/video.vue");
const Cardcharge = () =>
  import(/* webpackChunkName: "changecd" */ "@/view/changecd/custcharge.vue");
const CardPlain = () =>
    import(/* webpackChunkName: "changecd" */ "@/view/changecd/plaincard.vue");
// end ----  补换卡

// begin ----  销户

const Offorder = () => import(/* webpackChunkName: "off" */ "@/view/off/");

const OffVerify = () =>
  import(/* webpackChunkName: "off" */ "@/view/off/verify.vue");
const Offvideo = () =>
  import(/* webpackChunkName: "off" */ "@/view/off/video.vue");
const Refund = () =>
  import(/* webpackChunkName: "off" */ "@/view/off/refund.vue");
const Offcode = () =>
    import(/* webpackChunkName: "off" */ "@/view/off/code.vue");
const OffOutStandFee = () =>
    import(/* webpackChunkName: "off" */ "@/view/off/outStandFree.vue");
// const  Offcharge = () => import(/* webpackChunkName: "off" */'@/view/off/custcharge.vue')
// end ----  销户

// begin -代理商实名

// const  Agtcheck = () => import(/* webpackChunkName: "agent" */'lianlian/newboss-wx/src/view/remind/router')
const Agtfront = () =>
  import(/* webpackChunkName: "agent" */ "@/view/agent/front.vue");
const Agtback = () =>
  import(/* webpackChunkName: "agent" */ "@/view/agent/back.vue");
const Agtvideo = () =>
  import(/* webpackChunkName: "agent" */ "@/view/agent/video.vue");
const Agthat = () =>
    import(/* webpackChunkName: "agent" */ "@/view/agent/hat.vue");
const Agtface = () =>
    import(/* webpackChunkName: "agent" */ "@/view/agent/face.vue");
// end -代理商实名
// begin -CRM实名

// const  Agtcheck = () => import(/* webpackChunkName: "agent" */'lianlian/newboss-wx/src/view/remind/router')
const Sysfront = () =>
    import(/* webpackChunkName: "agent" */ "@/view/sysuser/front.vue");
const Sysback = () =>
    import(/* webpackChunkName: "agent" */ "@/view/sysuser/back.vue");
const Sysvideo = () =>
    import(/* webpackChunkName: "agent" */ "@/view/sysuser/video.vue");
const Syshat = () =>
    import(/* webpackChunkName: "agent" */ "@/view/sysuser/hat.vue");
const Sysface = () =>
    import(/* webpackChunkName: "agent" */ "@/view/sysuser/face.vue");
// end -CRM实名

// 购买结果
const BuyRes = () => import("@/view/remind/buy_res.vue");
const GiftRes = () => import("@/view/remind/gift_res.vue");
const ActiveRes = () => import("@/view/remind/active_res.vue");
const ApplyRes = () => import("@/view/remind/apply_res.vue");
const Phoneres = () => import("@/view/remind/laidian_res.vue");
const Over = () => import("@/view/remind/over.vue");

// beign--中秋活动
const Prodmid = () =>
  import(/* webpackChunkName: "midAutumn" */ "@/view/midAutumn/selectprod.vue");
const Nummid = () =>
  import(/* webpackChunkName: "midAutumn" */ "@/view/midAutumn/selectnum.vue");
const VerifyMid = () =>
  import(/* webpackChunkName: "midAutumn" */ "@/view/midAutumn/verify.vue");
const ForeignVerifyMid = () =>
    import(/* webpackChunkName: "midAutumn" */ "@/view/midAutumn/foreignverify.vue");

// const Fortune = () => import(/* webpackChunkName: "midAutumn" */'@/view/midAutumn/fortune.vue')
const Addmid = () =>
  import(/* webpackChunkName: "midAutumn" */ "@/view/midAutumn/address.vue");
const VideoMid = () =>
    import(/* webpackChunkName: "midAutumn" */ "@/view/midAutumn/onlinevideo.vue");
// end--中秋活动

// begin -个人对个人过户

const TransferOrdertwo = () =>
  import(/* webpackChunkName: "transfertwo" */ "@/view/transfertwo/");
const TransferVerify = () =>
  import(/* webpackChunkName: "transfertwo" */ "@/view/transfertwo/verify.vue");
const TransferGp = () =>
  import(
    /* webpackChunkName: "transfertwo" */ "@/view/transfertwo/groupphoto.vue"
  );
const TransferVideotwo = () =>
  import(/* webpackChunkName: "transfertwo" */ "@/view/transfertwo/video.vue");
const NewTransferVerify = () =>
  import(
    /* webpackChunkName: "transfertwo" */ "@/view/transfertwo/newUser/newverify.vue"
  );
const NewTransferGp = () =>
  import(
    /* webpackChunkName: "transfertwo" */ "@/view/transfertwo/newUser/groupphoto.vue"
  );
const NewTransferVideo = () =>
  import(
    /* webpackChunkName: "transfertwo" */ "@/view/transfertwo/newUser/video.vue"
  );
const handTransferSignResult = () =>
    import(/* webpackChunkName: "activate" */ "@/view/transfertwo/newUser/result.vue");
// end -个人对个人过户

//begin  短信意愿需求

const SmsRigsterMark = () =>
    import(/* webpackChunkName: "activate" */ "@/view/smswish/marketingSmsRigster.vue");
const SmsWishOrder = () =>
    import(/* webpackChunkName: "activate" */ "@/view/smswish/code.vue");
const RefuseNumber = () =>
    import(/* webpackChunkName: "activate" */ "@/view/smswish/refuseNumber.vue");
const SmsWishInfo = () =>
    import(/* webpackChunkName: "activate" */ "@/view/smswish/smsWishInfo.vue");
const AppealChannel = () =>
    import(/* webpackChunkName: "activate" */ "@/view/smswish/appealChannel.vue");
const SmsWish = () => import(/* webpackChunkName: "smswish" */ "@/view/smswish");
const ApplyForm = () =>
    import(/* webpackChunkName: "activate" */ "@/view/smswish/applyForm.vue");
//END  短信意愿需求
//反诈调查问卷
const AntFraundQuestion = () =>
    import(/* webpackChunkName: "activate" */ "@/view/antifraund/antfraudQuestions.vue");
//智能客服
const intelAutoReplay = () =>
    import(/* webpackChunkName: "activate" */ "@/view/kf/index.vue");
//网渠授权
const channelAuthorization = () =>
    import(/* webpackChunkName: "activate" */ "@/view/wq/index.vue");
// begin -靓号网渠实名
const Wqfront = () =>
    import(/* webpackChunkName: "agent" */ "@/view/wq/front.vue");
const Wqback = () =>
    import(/* webpackChunkName: "agent" */ "@/view/wq/back.vue");
const Wqhat = () =>
    import(/* webpackChunkName: "agent" */ "@/view/wq/hat.vue");
// end -靓号网渠实名

//add 新增销户

const useroffApply = () => import(/* webpackChunkName: "useroff" */ "@/view/useroff");
const accountClosure = () =>
    import(/* webpackChunkName: "changecd" */ "@/view/useroff/AccountClosureView.vue");

//end 销户




// 来显办理
const Ldxs = () =>
  import(/* webpackChunkName: "midAutumn" */ "@/view/prodused/ldxs.vue");
// 国际语音
const inter = () =>
    import(/* webpackChunkName: "midAutumn" */ "@/view/prodused/inter.vue");
const routes = [
  {
    path: "/ldxs",
    name: "ldxs",
    component: Ldxs,
    meta: {
      title: "来显办理",
      requireAuth: true,
    },
  },
  {
    path: "/inter",
    name: "inter",
    component: inter,
    meta: {
      title: "国际产品办理",
      requireAuth: true,
    },
  },

  // BEGIN-个人对个人过户
  {
    path: "/transferOrdertwo",
    name: "transferOrdertwo",
    component: TransferOrdertwo,
    meta: {
      title: "过户",
    },
  },
  {
    path: "/transferVerify",
    name: "transferVerify",
    component: TransferVerify,
    meta: {
      title: "身份认证",
    },
  },
  {
    path: "/transferGp",
    name: "transferGp",
    component: TransferGp,
    meta: {
      title: "卡板合影",
    },
  },
  {
    path: "/transferVideotwo",
    name: "transferVideotwo",
    component: TransferVideotwo,
    meta: {
      title: "视频验证-过户",
    },
  },
  {
    path: "/newTransferVerify",
    name: "newTransferVerify",
    component: NewTransferVerify,
    meta: {
      title: "新客户身份认证",
    },
  },
  {
    path: "/newTransferGp",
    name: "newTransferGp",
    component: NewTransferGp,
    meta: {
      title: "新客户身份认证",
    },
  },
  {
    path: "/newTransferVideo",
    name: "newTransferVideo",
    component: NewTransferVideo,
    meta: {
      title: "新客户视频验证-过户",
    },
  },
  {
    path: "/handTransferSignResult",
    name: "handTransferSignResult",
    component: handTransferSignResult,
    meta: {
      title: "手写签名-过户",
    },
  },

  // end-个人对个人过户
  // beign--中秋活动
  {
    path: "/prodMid",
    name: "prodMid",
    component: Prodmid,
    meta: {
      title: "选择套餐",
    },
  },
  {
    path: "/nummid",
    name: "nummid",
    component: Nummid,
    meta: {
      title: "选择号码",
    },
  },

  {
    path: "/verifyMid",
    name: "verifyMid",
    component: VerifyMid,
    meta: {
      title: "上传身份证",
    },
  },
  {
    path: "/foreignVerifyMid",
    name: "foreignVerifyMid",
    component: ForeignVerifyMid,
    meta: {
      title: "上传永居证",
    },
  },
  {
    path: "/addmid",
    name: "addmid",
    component: Addmid,
    meta: {
      title: "收件地址",
    },
  },
  {
    path: "/videomid",
    name: "videomid",
    component: VideoMid,
    meta: {
      title: "活体验证",
    },
  },
  // end--中秋活动

  {
    path: "/gift_res",
    name: "gift_res",
    component: GiftRes,
    meta: {
      title: "购买结果",
    },
  },
  {
    path: "/buy_res",
    name: "buy_res",
    component: BuyRes,
    meta: {
      title: "购买结果",
    },
  },
  {
    path: "/over",
    name: "over",
    component: Over,
    meta: {
      title: "活动结束",
    },
  },
  {
    path: "/active_res",
    name: "active_res",
    component: ActiveRes,
    meta: {
      title: "激活结果",
    },
  },
  {
    path: "/apply_res",
    name: "apply_res",
    component: ApplyRes,
    meta: {
      title: "申请结果",
    },
  },

  // begin-代理商实名
  {
    path: "/agtfront",
    name: "agtfront",
    component: Agtfront,
    meta: {
      title: "身份证正面校验",
    },
  },
  {
    path: "/agtback",
    name: "agtback",
    component: Agtback,
    meta: {
      title: "身份证反面验证",
    },
  },
  {
    path: "/agtvideo",
    name: "agtvideo",
    component: Agtvideo,
    meta: {
      title: "视频认证",
    },
  },
  {
    path: "/agthat",
    name: "agthat",
    component: Agthat,
    meta: {
      title: "免冠照验证",
    },
  },
  {
    path: "/agtface",
    name: "agtface",
    component: Agtface,
    meta: {
      title: "视频验证",
    },
  },
  // end-代理商实名
  // begin-CRM实名
  {
    path: "/sysfront",
    name: "sysfront",
    component: Sysfront,
    meta: {
      title: "身份证正面校验",
    },
  },
  {
    path: "/sysback",
    name: "sysback",
    component: Sysback,
    meta: {
      title: "身份证反面验证",
    },
  },
  {
    path: "/sysvideo",
    name: "sysvideo",
    component: Sysvideo,
    meta: {
      title: "视频认证",
    },
  },
  {
    path: "/syshat",
    name: "syshat",
    component: Syshat,
    meta: {
      title: "免冠照验证",
    },
  },
  {
    path: "/sysface",
    name: "sysface",
    component: Sysface,
    meta: {
      title: "视频认证",
    },
  },
  // end-CRM实名
  {
    path: "*",
    redirect: "/home",
  },

  // begin-销户
  {
    path: "/useroff",
    name: "useroff",
    component: Offorder,
    meta: {
      title: "销户",
      //snsapiBase: true,
    },
  },
  {
    path: "/offVerify",
    name: "offVerify",
    component: OffVerify,
    meta: {
      title: "反面校验-销户",
    },
  },
  {
    path: "/offvideo",
    name: "offvideo",
    component: Offvideo,
    meta: {
      title: "视频验证-销户",
    },
  },
  {
    path: "/offcode",
    name: "offcode",
    component: Offcode,
    meta: {
      title: "短信验证-销户",
    },
  },
  {
    path: "/offOutStandFee",
    name: "offOutStandFee",
    component: OffOutStandFee,
    meta: {
      title: "补齐欠费-销户",
    },
  },
  {
    path: "/refund",
    name: "refund",
    component: Refund,
    meta: {
      title: "账户信息",
    },
  },
  // end-销户

  // begin-补换卡

  {
    path: "/cardorder",
    name: "cardorder",
    component: Cardorder,
    meta: {
      title: "补换卡",
    },
  },

  {
    path: "/cardVerify",
    name: "cardVerify",
    component: CardVerify,
    meta: {
      title: "正面校验-补换卡",
    },
  },
  {
    path: "/cardvideo",
    name: "cardvideo",
    component: Cardvideo,
    meta: {
      title: "视频验证-补换卡",
    },
  },
  {
    path: "/cardcharge",
    name: "cardcharge",
    component: Cardcharge,
    meta: {
      title: "邮寄地址",
    },
  },
  {
    path: "/cardplain",
    name: "cardplain",
    component: CardPlain,
    meta: {
      title: "补换卡进度查询",
      requireAuth: true,
    },
  },
  // end-补换卡

  // begin--激活类型选择-分流
  {
    path: "/realcheck",
    name: "realcheck",
    component: Realcheck,
    meta: {
      title: "实名制补录",
      //keepAlive: true, //当前的.vue文件需要缓存
      snsapiBase: true, //生产开启
    },
  },
  {
    path: "/realverify",
    name: "realverify",
    component: Realverify,
    meta: {
      title: "身份证",
    },
  },
  {
    path: "/realhe",
    name: "realhe",
    component: Realgroupphoto,
    meta: {
      title: "合影",
    },
  },
  {
    path: "/realfront",
    name: "realfront",
    component: Realfront,
    meta: {
      title: "身份证正面验证",
    },
  },
  {
    path: "/realback",
    name: "realback",
    component: Realback,
    meta: {
      title: "身份证反面验证",
    },
  },
  {
    path: "/realVideo",
    name: "realVideo",
    component: RealVideo,
    meta: {
      title: "视频验证",
    },
  },
  {
    path: "/realVideoTu",
    name: "realVideoTu",
    component: RealTuVideo,
    meta: {
      title: "视频验证",
    },
  },
  {
    path: "/record",
    name: "record",
    component: Record,
    meta: {
      title: "录制承诺书视频",
    },

  },
  {
    path: "/liveresult",
    name: "liveresult",
    component: LiveResult,
    meta: {
      title: "活体结果",
    },

  },
  // end--激活类型选择-分流

  // begin--激活类型选择-分流
  {
    path: "/gettype",
    name: "gettype",
    component: Gettype,
    meta: {
      title: "号卡激活校验",
    },
  },
  // end--激活类型选择-分流

  {
    path: "/idqueryorder",
    name: "idqueryorder",
    component: Idqueryorder,
    meta: {
      title: "名下号码查询",
    },
  },

  {
    path: "/idqueryfront",
    name: "idqueryfront",
    component: Idqueryfront,
    meta: {
      title: "正面校验-名下号码查询",
    },
  },

  {
    path: "/idqueryback",
    name: "idqueryback",
    component: Idqueryback,
    meta: {
      title: "反面面校验-名下号码查询",
    },
  },

  {
    path: "/idqueryvideo",
    name: "idqueryvideo",
    component: Idqueryvideo,
    meta: {
      title: "视频验证-名下号码查询",
    },
  },

  {
    path: "/idquerylist",
    name: "idquerylist",
    component: Idquerylist,
    meta: {
      title: "查询结果",
    },
  },
  {
    path: "/idqueryliveresult",
    name: "idqueryliveresult",
    component: IdqueryLiveResult,
    meta: {
      title: "活体结果",
    },
  },
  {
    path: "/idqueryhat",
    name: "idqueryhat",
    component: Idqueryhat,
    meta: {
      title: "活体结果",
    },
  },


  {
    path: "/img",
    name: "img",
    component: Img,
    meta: {
      title: "图片压缩",
    },
  },

  // begin--补换卡
  {
    path: "/replaceorder",
    name: "replaceorder",
    component: Replaceorder,
    meta: {
      title: "补换卡",
      // snsapiBase: true
    },
  },
  {
    path: "/replacefront",
    name: "replacefront",
    component: Replacefront,
    meta: {
      title: "补换卡-身份证正面校验",
      // snsapiBase: true
    },
  },
  {
    path: "/replaceback",
    name: "replaceback",
    component: Replaceback,
    meta: {
      title: "补换卡-身份证反面校验",
      // snsapiBase: true
    },
  },
  {
    path: "/replacevideo",
    name: "replacevideo",
    component: Replacevideo,
    meta: {
      title: "补换卡-视频认证",
      // snsapiBase: true
    },
  },
  // end--补换卡
  {
    path: "/actorder",
    name: "actorder",
    component: Actorder,
    meta: {
      title: "预开户激活",
      keepAlive: true, //当前的.vue文件需要缓存
      snsapiBase: true, //生产开启
    },
  },

  {
    path: "/actverify",
    name: "actverify",
    component: Actverify,
    meta: {
      title: "身份证验证",
    },
  },
  {
    path: "/foreignverify",
    name: "foreignverify",
    component: ForeignVerify,
    meta: {
      title: "永居证验证",
    },
  },
  {
    path: "/actgroupphoto",
    name: "actgroupphoto",
    component: Actgroupphoto,
    meta: {
      title: "合照验证",
    },
  },

  {
    path: "/actvideo",
    name: "actvideo",
    component: Actvideo,
    meta: {
      title: "视频认证",
    },
  },
  {
    path: "/actvideoTU",
    name: "actvideoTU",
    component: ActvideoTU,
    meta: {
      title: "视频认证",
    },
  },
  // Onlinevideo 用户预约
  {
    path: "/onlinevideo",
    name: "onlinevideo",
    component: Onlinevideo,
    meta: {
      title: "视频认证",
    },
  },
  {
    path: "/actchargeprod",
    name: "actchargeprod",
    component: Actchargeprod,
    meta: {
      title: "开户充值-263",
      snsapiBase: true,
    },
  },
  {
    path: "/handSignResult",
    name: "handSignResult",
    component: handSignResult,
    meta: {
      title: "手写签名结果",
    },

  },
  {
    path: "/charge/act",
    name: "actcharge",
    component: Actcharge,
    meta: {
      title: "开户充值",
      snsapiBase: true,
    },
  },

  {
    path: "/chargedist/",
    name: "chargedist",
    component: ChargedisSrc,
    meta: {
      title: "话费充值",
      // snsapi_base:''
      snsapiBase: true,
    },
  },
  {
    path: "/riceCharge/",
    name: "riceCharge",
    component: RiceCharge,
    meta: {
      title: "激活成功",
      // snsapi_base:''
      // snsapiBase: true
    },
  },

  {
    path: "/rechargeorder/",
    name: "rechargeorder",
    component: Rechargeorder,
    meta: {
      title: "充值记录",
      requireAuth: true,
    },
  },

  {
    path: "/baseinfo",
    name: "baseinfo",
    component: Baseinfo,
    meta: {
      title: "我的基本信息",
      requireAuth: true,
    },
  },

  {
    path: "/bill",
    name: "bill",
    component: Bill,
    meta: {
      title: "月账单",
      requireAuth: true,
    },
  },
  // Pay history
  {
    path: "/prodused",
    name: "prodused",
    component: Prodused,
    meta: {
      title: "套餐",
      requireAuth: true,
    },
  },
  {
    path: "/payhistory",
    name: "payhistory",
    component: Payhistory,
    meta: {
      title: "充值记录",
      // requireAuth: true
    },
  },
  {
    path: "/detail",
    name: "detail",
    component: Detail,
    meta: {
      title: "详单查询",
      requireAuth: true,
    },
  },
  {
    path: "/interim",
    name: "interim",
    component: Interim,
    meta: {
      title: "身份验证",
      requireAuth: true,
    },
  },
  {
    path: "/query",
    name: "query",
    component: Query,
    meta: {
      title: "查询功能",
      // requireAuth: true
    },
  },
  {
    path: "/manage",
    name: "manage",
    component: Manage,
    meta: {
      title: "业务办理",
      // requireAuth: true
    },
  },
  {
    path: "/voice",
    name: "voice",
    component: Voice,
    meta: {
      title: "语音详单",
      requireAuth: true,
    },
  },
  {
    path: "/mess",
    name: "mess",
    component: Mess,
    meta: {
      title: "短信详单",
      requireAuth: true,
    },
  },
  {
    path: "/mms",
    name: "mms",
    component: Mms,
    meta: {
      title: "彩信详单",
      requireAuth: true,
    },
  },
  {
    path: "/web",
    name: "web",
    component: Web,
    meta: {
      title: "流量详单",
      requireAuth: true,
    },
  },
  {
    path: "/remind",
    name: "remind",
    component: Remind,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      title: "二六三",
      // requireAuth: true,
    },
  },
  {
    path: "/protocolchange",
    name: "protocolchange",
    component: Protocolchange,
    meta: {
      title: "协议变更",
      // requireAuth: true,
    },
  },

  {
    path: "/fee",
    name: "fee",
    component: Fee,
    meta: {
      title: "实时话费",
      requireAuth: true,
    },
  },
  {
    path: "/testReturn",
    name: "testReturn",
    component: TestReturn,
    meta: {
      title: "测试跳转小程序",
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "服务密码登录",
      weixinAuth: true,
    },
  },
  {
    path: "/codelogin",
    name: "codelogin",
    component: Code,
    meta: {
      title: "验证码登录",
      // requireAuth: true,
      weixinAuth: true,
    },
  },
  {
    path: "/reset",
    name: "reset",
    component: Reset,
    meta: {
      title: "服务密码重置",
      // requireAuth: true,
      weixinAuth: true,
    },
  },
  // forget
  {
    path: "/forget",
    name: "forget",
    component: Forget,
    meta: {
      title: "忘记密码",
      // requireAuth: true
    },
  },
  {
    path: "/user",
    name: "user",
    component: User,
    meta: {
      title: "会员中心",
      //TODO: remove
      requireAuth: true,
    },
  },
  {
    path: "/cart",
    name: "cart",
    component: Cart,
    meta: {
      title: "购物车",
    },
  },
  {
    path: "/goods",
    name: "goods",
    component: Goods,
    meta: {
      title: "商品详情",
    },
  },
  {
    path: "/about",
    name: "about",
    component: About,
    meta: {
      title: "about",
      requireAuth: true,
    },
  },

  {
    path: "/phoneres",
    name: "phoneres",
    component: Phoneres,
    meta: {
      title: "神秘来电预约",
      // snsapiBase: true
    },
  },
    //add 天津渠道
  {
    path: "/TJactorder",
    name: "TJactorder",
    component: TJActorder,
    meta: {
      title: "预开户激活",
      keepAlive: true, //当前的.vue文件需要缓存
      snsapiBase: true, //生产开启
    },
  },

  {
    path: "/TJactverify",
    name: "TJactverify",
    component: TJActverify,
    meta: {
      title: "身份证验证",
    },
  },

  {
    path: "/TJactgroupphoto",
    name: "TJactgroupphoto",
    component: TJActgroupphoto,
    meta: {
      title: "合照验证",
    },
  },

  {
    path: "/TJactvideo",
    name: "TJactvideo",
    component: TJActvideo,
    meta: {
      title: "视频认证",
    },
  },
  {
    path: "/TJactvideoTU",
    name: "TJactvideoTU",
    component: TJActvideoTU,
    meta: {
      title: "视频认证",
    },
  },

  {
    path: "/TJVideoScreenshot",
    name: "TJVideoScreenshot",
    component: TJVideoScreenshot,
    meta: {
      title: "视频截图",
    },
  },


  // Onlinevideo 用户预约
  {
    path: "/TJonlinevideo",
    name: "TJonlinevideo",
    component: TJOnlinevideo,
    meta: {
      title: "视频认证",
    },
  },
  {
    path: "/TJactchargeprod",
    name: "TJactchargeprod",
    component: TJActchargeprod,
    meta: {
      title: "开户充值-263",
      snsapiBase: true,
    },
  },
  {
    path: "/TJSignResult",
    name: "TJSignResult",
    component: TJSignResult,
    meta: {
      title: "手写签名结果",
    },
  },
  // BEGIN-短信意愿
  {
    path: "/marketSmsRigster",
    name: "marketSmsRigster",
    component: SmsRigsterMark,
    meta: {
      title: "行业营销类别防护",
      requireAuth: true,

    },
  },
  {
    path: "/smsWishOrder",
    name: "smsWishOrder",
    component: SmsWishOrder,
    meta: {
      title: "短信免打扰订购",
    },
  },
  {
    path: "/refuseNum",
    name: "refuseNum",
    component: RefuseNumber,
    meta: {
      title: "拒收号码名单",
      requireAuth: true,

    },
  },
  {
    path: "/smsWishInfo",
    name: "smsWishInfo",
    component: SmsWishInfo,
    meta: {
      title: "短信意愿信息",
    },
  },
  {
    path: "/appealChannel",
    name: "appealChannel",
    component: AppealChannel,
    meta: {
      title: "客户服务",
    },

  },
  {
    path: "/applyForm",
    name: "applyForm",
    component: ApplyForm,
    meta: {
      title: "拦截申诉",
    },

  },
  {
    path: "/smswish",
    name: "smswish",
    component: SmsWish,
    meta: {
      title: "短信免打扰",
    },

  },
    //反诈调查问卷 AntFraundQuestion
  {
    path: "/antFraundQuestion",
    name: "antFraundQuestion",
    component: AntFraundQuestion,
    meta: {
      title: "反诈调查问卷",
      // snsapiBase: true,
    },

  },
  //intelAutoReplay

  {
    path: "/intelAutoReplay",
    name: "intelAutoReplay",
    component: intelAutoReplay,
    meta: {
      title: "智能客服",
      // snsapiBase: true,
    },

  },
  {
    path: "/channelAuthorization",
    name: "channelAuthorization",
    component: channelAuthorization,
    meta: {
      title: "授权网点",
      // snsapiBase: true,
    },

  },
  // begin-网渠靓号实名
  {
    path: "/wqfront",
    name: "wqfront",
    component: Wqfront,
    meta: {
      title: "身份证正面校验",
    },
  },
  {
    path: "/wqback",
    name: "wqback",
    component: Wqback,
    meta: {
      title: "身份证反面验证",
    },
  },
  {
    path: "/wqhat",
    name: "wqhat",
    component: Wqhat,
    meta: {
      title: "免冠照验证",
    },
  },
  // end-靓号网渠实名
    //销户入口

  {
    path: "/useroffApply",
    name: "useroffApply",
    component: useroffApply,
    meta: {
      title: "销户",
      requireAuth: true,
    },
  },
  {
    path: "/accountClosure",
    name: "accountClosure",
    component: accountClosure,
    meta: {
      title: "销户进度查询",
    },
  },


];

// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({ routes });

router.beforeEach(async (to, from, next) => {
  const title = to.meta && to.meta.title;
  let token_cookie = getCookie("token");
  if (title) {
    document.title = title;
  }
  // 使用微信授权登录的方式  该步骤暂时隐去
  if (to.matched.some((r) => r.meta.requireAuth)) {
    if (token_cookie) {
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
        // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
  // 微信授权登录
  if (to.matched.some((recode) => recode.meta.weixinAuth)) {
    console.log("wxuser===");
    let wxuserinfo = store.state.login.wxuserinfo;
    console.log(wxuserinfo);
    // this.$store.state.login.wxuserinfo
    if (Object.keys(wxuserinfo).length !== 0) {
      next();
      return;
    }
    // if(Object.keys(localStorage_vuex).length !== 0){
    //     if (localStorage_vuex.root.login.nickname) {
    //         console.log('获取到了localStorage_vuex')
    //         store.commit('login/setUserInfo', localStorage_vuex.login.wxuserinfo)
    //         next()
    //         return
    //     }
    // }
    // if(localStorage_weixin){
    //     if (localStorage_weixin.nickname) {
    //         console.log('获取到了localStorage_weixin')
    //         store.commit('login/setUserInfo', localStorage_weixin)
    //         next()
    //         return
    //     }
    // }
    const code = getUrlParams("code"); // 截取url上的code ,可能没有,则返回''空字符串
    if (typeof code == "undefined") {
      console.log(window.location.origin);
      console.log(to.fullPath);
      // 这个redirectUrl用 当前页路径或者tof.fullPath(将要进入的路径)
      // let redirectUrl = window.location.href
      let redirectUrl = window.location.origin + "/#" + to.fullPath;
      redirectUrl = encodeURIComponent(redirectUrl);
      console.log(redirectUrl);
      const appid = "wx1d2511611a21f403"; //公众号迁移修改
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
    } else {
      console.log("code:  " + code);
      let res = await new Promise(function (resolve, reject) {
        let openid = oauthbycode(code);
        resolve(openid);
      });

      // let res = oauthbycode(code) // 获取用户信息,后端可首先通过cookie,session等判断,没有信息则通过code获取

      console.log(res);
      if (res.status === 200) {
        if (res.data.code == 0) {
          console.log("coming");
          let wxuser = {
            openid: res.data.openid,
            nickname: res.data.nickname,
            headimgurl: res.data.headimgurl,
          };
          // setCookie = ('wxuser',value,6404800)
          // // this.$store.commit('productlist/getStoreListShow', data.page.list)
          store.commit("login/setUserInfo", res.data);
          // weixinStorage.save(res.data)
          // console.log(res.data.nickname)
          window.location.href = window.location.origin + "/#" + to.fullPath;
          // next()
        } else if (res.data.code == 40163) {
          console.log(window.location.origin);
          console.log(to.fullPath);
          // 这个redirectUrl用 当前页路径或者tof.fullPath(将要进入的路径)
          let redirectUrl = window.location.origin + "/#" + to.fullPath;
          redirectUrl = encodeURIComponent(redirectUrl);
          console.log(redirectUrl);
          const appid = "wx1d2511611a21f403"; //公众号迁移修改
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
        }
      } else {
        // 上面的获取用户信息接口,如果cookie,session拿不到用户信息,且传递的code为空,则跳转到微信授权页面
        if (res.status === 202) {
          console.log(window.location.origin);
          console.log(to.fullPath);
          // 这个redirectUrl用 当前页路径或者tof.fullPath(将要进入的路径)
          let redirectUrl = window.location.origin + "/#" + to.fullPath;
          redirectUrl = encodeURIComponent(redirectUrl);
          console.log(redirectUrl);
          const appid = "wx1d2511611a21f403"; //263 公众号迁移修改
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
        }
      }
    }
    // 返回用户信息
    // {"openid":"o5Tqx0eAhGBW2einiqTyxaqT-l7g","nickname":"许仙","sex":1,"language":"zh_CN","city":"杭州","province":"浙江","country":"中国","headimgurl":"http://thirdwx.qlogo.cn/mmopen/vi_32/ibhtj6joaSEaaR3wplCGwPHrHA0m4ZBicWcAgzE0qqm12s4icVSdRwKGzefIrvsmVhM0bDQ1f1ibGGkzyoic8Gx1FYw/132","privilege":[]}
  } else {
    next();
  }
  // 微信 静默授权  snsapiBase    {msg: "success", code: 0, openid: "oanVsuOLU5sfaNVldrIz91xlzWLE", nickname: "许仙", headimgurl: "http://thirdwx.qlogo.cn/mmopen/vi_32/uKo8NYAN7FQOO…UkAART7xoJbdKLXG4dIBS9myYPErb5TRqgRicBpKqiafw/132"}
  if (to.matched.some((recode) => recode.meta.snsapiBase)) {
    console.log("openid===");
    console.log(getCookie("openid"));
    if (getCookie("openid")) {
      next();
      return;
    }
    // if(Object.keys(localStorage_vuex).length !== 0){
    //     if (localStorage_vuex.root.login.nickname) {
    //         console.log('获取到了localStorage_vuex')
    //         store.commit('login/setUserInfo', localStorage_vuex.login.wxuserinfo)
    //         next()
    //         return
    //     }
    // }
    // if(localStorage_weixin){
    //     if (localStorage_weixin.nickname) {
    //         console.log('获取到了localStorage_weixin')
    //         store.commit('login/setUserInfo', localStorage_weixin)
    //         next()
    //         return
    //     }
    // }
    const code = getUrlParams("code"); // 截取url上的code ,可能没有,则返回''空字符串
    if (typeof code == "undefined") {
      console.log(window.location.origin);
      console.log(to.fullPath);
      // 这个redirectUrl用 当前页路径或者tof.fullPath(将要进入的路径)
      // let redirectUrl = window.location.href
      let redirectUrl = window.location.origin + "/#" + to.fullPath;
      redirectUrl = encodeURIComponent(redirectUrl);
      console.log(redirectUrl);
      const appid = "wx1d2511611a21f403"; //263 公众号迁移修改
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
    } else {
      console.log("code:  " + code);
      let res = await new Promise(function (resolve, reject) {
        let openid = oauthbycode(code);
        resolve(openid);
      });

      // let res = oauthbycode(code) // 获取用户信息,后端可首先通过cookie,session等判断,没有信息则通过code获取
      console.log("oauthbycode-resres:::::");
      console.log(res);
      if (res.status === 200) {
        if (res.data.code == 0) {
          console.log("coming");
          // let  wxuser = {
          //     openid:res.data.openid
          //     // nickname:res.data.nickname,
          //     // headimgurl:res.data.headimgurl
          // }
          let openid = res.data.openid;
          setCookie("openid", openid, 6404800);
          // // this.$store.commit('productlist/getStoreListShow', data.page.list)
          // store.commit('login/setUserInfo', res.data)
          // weixinStorage.save(res.data)
          // console.log(res.data.nickname)
          window.location.href = window.location.origin + "/#" + to.fullPath;

          // next()
        } else if (res.data.code == 40163) {
          console.log(window.location.origin);
          console.log(to.fullPath);
          // 这个redirectUrl用 当前页路径或者tof.fullPath(将要进入的路径)
          let redirectUrl = window.location.origin + "/#" + to.fullPath;
          redirectUrl = encodeURIComponent(redirectUrl);
          console.log(redirectUrl);
          const appid = "wx1d2511611a21f403"; //263 公众号迁移修改
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
        }
      } else {
        // 上面的获取用户信息接口,如果cookie,session拿不到用户信息,且传递的code为空,则跳转到微信授权页面
        if (res.status === 202) {
          console.log(window.location.origin);
          console.log(to.fullPath);
          // 这个redirectUrl用 当前页路径或者tof.fullPath(将要进入的路径)
          let redirectUrl = window.location.origin + "/#" + to.fullPath;
          redirectUrl = encodeURIComponent(redirectUrl);
          console.log(redirectUrl);
          const appid = "wx1d2511611a21f403"; // 公众号迁移修改
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
        }
      }
    }
    // 返回用户信息
    // {"openid":"o5Tqx0eAhGBW2einiqTyxaqT-l7g","nickname":"许仙","sex":1,"language":"zh_CN","city":"杭州","province":"浙江","country":"中国","headimgurl":"http://thirdwx.qlogo.cn/mmopen/vi_32/ibhtj6joaSEaaR3wplCGwPHrHA0m4ZBicWcAgzE0qqm12s4icVSdRwKGzefIrvsmVhM0bDQ1f1ibGGkzyoic8Gx1FYw/132","privilege":[]}
  } else {
    next();
  }
});

export { router };
